import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'
import { useUserContext } from 'shared/hooks/useUserContext'
import { isUserAnonymous } from 'shared/utils/isUserAnonymous'

import { containerApi } from '../..'
import { GetAppsResponse } from './getApps.types'

export const getApps = async () => {
  const response = await containerApi.get<GetAppsResponse>('/apps')
  return response.data.data
}
export const GET_APPS_QUERY_KEY = 'getApps'

export const useGetAppsQuery = (
  options?: ExtendableQueryOptions<GetAppsResponse['data']>
) => {
  const user = useUserContext()

  return useQuery({
    queryKey: [GET_APPS_QUERY_KEY],
    queryFn: getApps,
    // Anonymous and external-token sessions have no app grants to fetch —
    // public apps resolve from publicAppConfigs instead, and an external
    // token would only 401 here. (Passing user.user, not the context object,
    // is what actually makes the anonymous check work.)
    enabled:
      !!user.user && !isUserAnonymous(user.user) && !user.user.isExternalAuth,
    ...options
  })
}
